import httpRequest from '../../ajax';
import {
  GET_COUNTRIES,
  ERROR,
} from '../actionTypes';

/**
 * @description get country action
 * @function getCountryAction
 * @param {function} dispatch - dispatch function
 * @returns {object} - returns the action
 */
export const getCountryAction = (dispatch) => httpRequest('get','/country')
  .then(({ data: { data }}) => {
    const action = { type: GET_COUNTRIES, payload: data };
    dispatch(action);
    return action;
  })
  .catch(({ response }) => ({
    payload: response?.data?.message,
    type: ERROR,
  }));
